import { Client } from '@features/authentication/services/OAuth2Service';

export function getClientSubtitle(client: Client | null, t: (key: string) => string): string {
  if (!client) {
    return t('login.identity.subtitle');
  }
  
  return client.clientBranding?.customSubtitle || t('login.identity.subtitle');
}
